(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jools-load-more')) {
  customElements.define('jools-load-more', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.link = this.querySelector('a');
      this.status = this.querySelector('[role=status]');
      this.link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!this.busy) this.load();
      }, {signal:this.controller.signal});
    }
    async load() {
      const root = this.closest('#ProductGridContainer');
      const grid = root?.querySelector('ul.product-grid');
      if (!grid) { location.assign(this.link.href); return; }
      this.busy = true;
      this.link.setAttribute('aria-disabled','true');
      this.status.classList.add('visually-hidden');
      this.status.textContent = this.dataset.loading;
      grid.setAttribute('aria-busy','true');
      try {
        const response = await fetch(this.link.href, {signal:this.controller.signal});
        if (!response.ok) throw new Error('Unable to load products');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.querySelector('#ProductGridContainer ul.product-grid');
        if (!nextGrid || !nextGrid.children.length) throw new Error('Missing products');
        if (!this.isConnected || root.querySelector('ul.product-grid') !== grid) return;
        const items = [...nextGrid.children];
        items.forEach(item => {
          item.classList.remove('scroll-trigger','animate--slide-in','scroll-trigger--offscreen');
          item.querySelectorAll('.scroll-trigger').forEach(el => el.classList.remove('scroll-trigger','scroll-trigger--offscreen','animate--slide-in','animate--fade-in'));
          grid.appendChild(item);
        });
        const next = doc.querySelector('#ProductGridContainer jools-load-more a');
        if (next) this.link.href = next.getAttribute('href');
        else this.link.hidden = true;
        this.status.textContent = this.dataset.loaded;
        const firstLink = items[0].querySelector('h3 a') || items[0].querySelector('a');
        firstLink?.focus({preventScroll:true});
      } catch(error) {
        if (error.name !== 'AbortError') {
          this.status.classList.remove('visually-hidden');
          this.status.textContent = this.dataset.error;
        }
      } finally {
        this.busy = false;
        this.link.removeAttribute('aria-disabled');
        grid.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
